// Recruitment4.tsx
import React, { FC } from "react";
//import { useAppDispatch, useAppSelector } from '@/app/lib/hooks';
import Checkbox from '@/shared/CheckboxCustom'; // Ensure this is the correct import path
//import { setGuidePreferences } from '@/app/lib/reducers/recruitmentReducer';
import { useTranslation } from "react-i18next";

export interface Recruitment4Props {}

const Recruitment4: FC<Recruitment4Props> = () => {
  const { t } = useTranslation("guydeez");

  // Categories and their options
  const categories = {
    [t('recruitment_categories_travelers_title')]: [
      t('recruitment_travelers_senior'), t('recruitment_travelers_families_children'), t('recruitment_travelers_solo'),
      t('recruitment_travelers_business'), t('recruitment_travelers_food_drink'), t('recruitment_travelers_off_beaten_path'),
      t('recruitment_travelers_high_profile'), t('recruitment_travelers_history_culture'), t('recruitment_travelers_lgbtq'), t('recruitment_travelers_nightlife'),
      t('recruitment_travelers_parks_nature')
    ],
    [t('recruitment_categories_availability_title')]: [
      t('recruitment_availability_weekdays'), t('recruitment_availability_evenings'), t('recruitment_availability_weekends'),
      t('recruitment_availability_needs_notice'), t('recruitment_availability_flexible')
    ],
    [t('recruitment_categories_prefer_tours_title')]: [
      t('recruitment_prefer_tours_4h'), t('recruitment_prefer_tours_8h'), t('recruitment_prefer_tours_bike_4h'), t('recruitment_prefer_tours_food'),
      t('recruitment_prefer_tours_street_art'), t('recruitment_prefer_tours_private_vehicle')
    ]
  } as Record<string, string[]>;

  return (
    <>
      <div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: "var(--g-burgundy)", lineHeight: 1.2 }}>
          {t('recruitment_few_more_questions_title')}
        </h2>
        <span className="block mt-2" style={{ fontSize: 13, color: "var(--g-ink-500)" }}>
          {t('recruitment_few_more_questions_subtitle')}
        </span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      <div className="space-y-8">
        {Object.entries(categories).map(([categoryName, options]) => (
          <div key={categoryName}>
            <label style={{ fontSize: 14, fontWeight: 700, color: "var(--g-burgundy)" }}>{categoryName}</label>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {options.map((option) => (
                <Checkbox
                  key={`${categoryName}-${option}`}
                  label={option}
                  categoryName={categoryName}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Recruitment4;
